import React, { useEffect, useState, useRef } from "react";
import './header.css';

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Modal2 from "../../components/modalsus2026/ModalSus";

const Header = () => {
    const [lang, setLang] = useState(localStorage.getItem("language") || "es");
    // const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [langText, setLangText] = useState(
        lang === "es" ? "English" : "Español"
    );
    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("ideas_libertad");
    const isFirstRender = useRef(true);
    const location = useLocation();
    const navigate = useNavigate();
    const queryParms = new URLSearchParams(location.search);
    console.log(queryParms.get("lang"));
    const inputRef = useRef(null);
    const inputRef2 = useRef(null);
    const inputRef3 = useRef(null);
    const [inputVal, setInputVal] = useState('');
    const langQueryParams = queryParms.get("lang");
    const [popup, setPopup] = useState(false); // Initialize the state in the parent component
    const [menuOpen, setMenuOpen] = useState(false);
    const [blogMenuOpen, setBlogMenuOpen] = useState(false);

    useEffect(() => {
        const urlLang = location.pathname.split("/")[1];
        if (["es", "en"].includes(urlLang)) {
            setLang(urlLang);
            localStorage.setItem("language", urlLang);
            i18n.changeLanguage(urlLang);
            setLangText(urlLang === "es" ? "English" : "Español");
        } else if (["es", "en"].includes(langQueryParams)) {
            setLang(langQueryParams);
            localStorage.setItem("language", langQueryParams);
            i18n.changeLanguage(langQueryParams);
            setLangText(langQueryParams === "es" ? "English" : "Español");
        } else {
            i18n.changeLanguage(lang);
            localStorage.setItem("language", lang);
        }
    }, [lang]);


    const changeLanguage = () => {
        console.log(lang);
        const newLang = lang === "es" ? "en" : "es";
        setLang(newLang);
        setLangText(newLang === "es" ? "English" : "Español");

        const urlLang = location.pathname.split("/")[1];
        if (["es", "en"].includes(urlLang)) {
            const newRoute = `/${newLang}${location.pathname.replace(
                `/${lang}`,
                ""
            )}`;
            navigate(newRoute);
        } else if (["es", "en"].includes(langQueryParams)) {
            const newSearchParams = new URLSearchParams(location.search);
            newSearchParams.set("lang", newLang);
            const newRoute = `${location.pathname}?${newSearchParams.toString()}`;
            navigate(newRoute);
        }
    };

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const [mostrarInput, setMostrarInput] = useState(false);

    const handleButtonClick = () => {
        setMostrarInput(prev => !prev);
    };

    const openModal2 = () => {


        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const handleInputChange = (event) => {
        setInputVal(event.target.value);
    };

    const handleClick = () => {
        if (inputVal != null && inputVal != '') {
            window.location.href = "/" + lang + "/busqueda/" + inputVal;
        }
    };

    const handleKeyDown = (e) => {
        // Verificar si la tecla presionada es "Enter" (código 13)
        if (e.key === 'Enter') {
            handleClick();
        }
    };

    {/* 
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Verificar si el clic ocurrió fuera del input
            if (inputRef.current && !inputRef.current.contains(event.target) && !inputRef2.current.contains(event.target) && (!inputRef3.current || !inputRef3.current.contains(event.target))) {
                // Ocultar el input si está visible
                if (mostrarInput) {
                    setMostrarInput(false);
                }
            }
        };

        // Agregar el manejador de eventos cuando el componente se monta
        document.addEventListener('mousedown', handleClickOutside);

        // Limpiar el manejador de eventos cuando el componente se desmonta
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [mostrarInput]); // Este efecto se ejecuta cada vez que mostrarInput cambia
    */}

    // Función para hacer focus en el input
    const hacerFocus = () => {
        // Verificar que la referencia no sea null antes de llamar al método focus
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        if (mostrarInput) {
            hacerFocus();
        }
    }, [mostrarInput]);

    const clearSearch = () => {
        setInputVal('');
    };


    return (
        <header className={`header header2026 ${menuOpen ? 'header--menu-open' : ''}`}>

            <div class="header__top">
                <div class="header__top-inner">

                    {/* 
                    <a href="/" className="logo-home-nav_a">
                        <img
                            src="/assets/img2026/logo_rs.svg"
                            alt="Ricardo Salinas"
                            className="bottom__brand-logo-home"
                        />
                    </a>*/}
                    <button
                        type="button"
                        className="header__icon-button header__search-button"
                        id="btnSearch"
                        onClick={handleButtonClick}
                    >
                        <img src="/assets/img2026/logo_search.svg" />
                    </button>

                    <button
                        type="button"
                        id="btnMenu"
                        className={`header__icon-button header__menu-button ${menuOpen ? 'header__menu-button--active' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span></span><span></span><span></span>
                    </button>

                    <p class="header__brand"><a href="/">RICARDO SALINAS</a></p>

                    <button id="btn_cm_idm" type="button" class="header__desktop-english" onClick={changeLanguage}>{langText}</button>
                    <button type="button" class="header__subscribe-button" onClick={() => openModal2()}>{(t('general.suscribirsebtn2'))}</button>

                </div>
            </div>


            <div
                id="header-mobile-menu"
                className={`header__mobile-menu ${menuOpen ? 'header__mobile-menu--open' : ''}`}
            >

                <div class="header__mobile-menu-shell">
                    <div class="header__mobile-menu-body">

                        <form class="header__mobile-search" onSubmit={(e) => {
                            e.preventDefault();
                            handleClick();
                        }}>
                            <label class="header__search-field">
                                <input type="search" placeholder={t('navbar.buscador2')} aria-label="Buscar contenido"
                                    value={inputVal}
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown} />
                                {inputVal && (
                                    <button
                                        type="button"
                                        ref={inputRef3}
                                        className="header__search-clear"
                                        onClick={clearSearch}
                                    >
                                        <img
                                            src="/assets/img2026/cerrar-cancelar.svg"
                                            alt="cancelar"
                                            aria-hidden="true"
                                        />
                                    </button>
                                )}

                                <img src="/assets/img2026/logo_search.svg" onClick={handleClick} alt="Buscar" aria-hidden="true" />
                            </label>
                        </form>

                        <nav class="header__nav header__nav--mobile">

                            <a href={"/" + lang + "/"} class="header__nav-link" onClick={() => setMenuOpen(false)}>
                                {t("navbar.inicio")}
                            </a>
                            <a href={"/" + lang + "/Ideas-en-Corto"} class="header__nav-link" onClick={() => setMenuOpen(false)}>
                                {t("navbar.ideas-corto")}
                            </a>
                            <a href={"/" + lang + "/biblioteca"} class="header__nav-link" onClick={() => setMenuOpen(false)}>
                                {t("navbar.biblioteca")}
                            </a>
                            <a href={"/" + lang + "/Sobre-mi"} class="header__nav-link" onClick={() => setMenuOpen(false)}>
                                {t("navbar.sobre-mi")}
                            </a>
                            <div className="header__mobile-dropdown">

                                <button
                                    type="button"
                                    className="header__nav-link header__nav-link--dropdown"
                                    onClick={() => setBlogMenuOpen(prev => !prev)}
                                >
                                    {t("navbar.ideas-libertad")}

                                    <span className={`header__dropdown-arrow ${blogMenuOpen ? 'open' : ''}`}>
                                        <img id="arrow-image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAOCAYAAADaOrdAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgBrdDdCcMgEADgKOIcrpJN2kcfncQn8bHdJKPUOUS0XkogpMacxoPDnzvvA4kx5jPl8N7PSik3DQqtteCcL7CnhBBY1wsoTANiBwiYD8ic042CDoBb50PBWitSSktOkY+u9+tKgJTSka3hLnQGQI3sG3uhGvCH9EBXQBFpgTDAKYKBsEAVqUEtwCVSgmKMT0rpCwugkAL0e4gE0MgRagGakA0KITwYY28sAPEFOszb+zcHGEQAAAAASUVORK5CYII=" />
                                    </span>
                                </button>

                                {
                                    blogMenuOpen && (
                                        <div className="header__mobile-submenu">

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=liderazgo"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-5'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=educacion"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-2'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=estado-de-derecho"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-7'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=medio-ambiente"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-4'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=libertad"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-1'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=arte-y-cultura"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-3'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=innovacion"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-6'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=prosperidad-incluyente"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-9'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog?categoria=biblioteca"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {(t2('categorias.categoria-8'))}
                                            </a>

                                            <a
                                                href={"/" + lang + "/Mi-blog"}
                                                className="header__nav-link not-strong-a"
                                                onClick={() => setMenuOpen(false)}
                                            >
                                                {((t('navbar.todas')))}
                                            </a>

                                        </div>
                                    )
                                }

                            </div>
                        </nav>

                        <div class="header__social header__social--mobile">
                            <p class="header__social-title">{(t('general.follow2'))}</p>
                            <div aria-label="Redes sociales" class="header__social-links">
                                <a class="header__social-link" target="_blank" href="https://x.com/ricardobsalinas" aria-label="X">
                                    <img src="/assets/img2026/logo_twitter.svg" alt="X" />
                                </a>
                                <a class="header__social-link" target="_blank" href="https://www.instagram.com/ricardosalinas/?hl=es-la" aria-label="Instagram">
                                    <img src="/assets/img2026/logo_instagram.svg" alt="Instagram" />
                                </a>
                                <a class="header__social-link" target="_blank" href="https://www.facebook.com/RicardoSalinasPliego" aria-label="Facebook">
                                    <img src="/assets/img2026/logo_facebook.svg" alt="Facebook" />
                                </a>
                                <a class="header__social-link" target="_blank" href="https://www.youtube.com/channel/UCovDaTdisIRpyFqQsNGMNsQ" aria-label="Youtube">
                                    <img src="/assets/img2026/logo_youtube.svg" alt="Youtube" />
                                </a>
                                <a class="header__social-link" target="_blank" href="https://www.tiktok.com/discover/ricardo-salinas-pliego?lang=es" aria-label="TikTok">
                                    <img src="/assets/img2026/logo_tiktok.svg" alt="TikTok" />
                                </a>
                            </div>
                        </div>
                        <div aria-label="English" class="header__mobile-footer-item" onClick={changeLanguage}> {langText} </div>

                    </div>
                </div>

            </div>


            <div class="header__content">
                <div class="header__content-inner">

                    <nav class="header__nav header__nav--desktop">
                        <a href={"/" + lang + "/Mi-blog"} class="header__nav-link">
                            {t("navbar.ideas-libertad")}
                        </a>
                        <a href={"/" + lang + "/Ideas-en-Corto"} class="header__nav-link">
                            {t("navbar.ideas-corto")}
                        </a>
                        <a href={"/" + lang + "/biblioteca"} class="header__nav-link">
                            {t("navbar.biblioteca")}
                        </a>
                        <a href={"/" + lang + "/Sobre-mi"} class="header__nav-link">
                            {t("navbar.sobre-mi")}
                        </a>
                    </nav>

                </div>
            </div>


            <div
                id="header-search"
                className={`header__search ${mostrarInput ? 'header__search--visible' : ''}`}
            >
                <div className="header__search-inner">

                    <form
                        className="header__search-form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleClick();
                        }}
                    >

                        <label className="header__search-field">

                            <input
                                ref={inputRef}
                                type="search"
                                placeholder={t('navbar.buscador2')}
                                aria-label="Buscar contenido"
                                value={inputVal}
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                            />

                            {inputVal && (
                                <button
                                    type="button"
                                    ref={inputRef3}
                                    className="header__search-clear"
                                    onClick={clearSearch}
                                >
                                    <img
                                        src="/assets/img2026/cerrar-cancelar.svg"
                                        alt="cancelar"
                                        aria-hidden="true"
                                    />
                                </button>
                            )}

                            <img
                                src="/assets/img2026/logo_search.svg"
                                alt="Buscar"
                                ref={inputRef2}
                                onClick={handleClick}
                            />

                        </label>

                    </form>

                </div>
            </div>

            <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
        </header>

    );
};

export default Header;